function traeGeneral() {
	if ( typeof tablePage != 'undefined' ) { tablePage.destroy(); }
	ajaxRequest( false, 'POST', { 'required': 'N' }, 'api/controller/columnas/' + tablaActual, armaTabla );
}
function armaTabla( respuesta ) {
	cargando( false );
	var datos = JSON.parse( respuesta );
	if ( datos.status == 'Success' ) {
		var parametros = { 'rol': obtenSesion( 'rolId' ), 'usuarioId': obtenSesion( 'usuarioId' ), 'required': 'N' };
        if ( categoriaActiva != 0 && $( '#categoriaFiltro' ).val() == '' ) { $( '#categoriaFiltro' ).val( categoriaActiva ); }
		if ( paisActivo != 0 && $( '#paisFiltro' ).val() == '' ) { $( '#paisFiltro' ).val( paisActivo ); }
		if ( estadoActivo != 0 && $( '#estadoFiltro' ).val() == '' ) { $( '#estadoFiltro' ).val( estadoActivo ); }
		if ( $( '#categoriaFiltro' ).length > 0 && $( '#categoriaFiltro' ).val() != '' && $( '#categoriaFiltro' ).val() != null ) { parametros[ 'categoriaId' ] = $( '#categoriaFiltro' ).val(); }
		if ( $( '#rolFiltro' ).length > 0 && $( '#rolFiltro' ).val() != '' && $( '#rolFiltro' ).val() != null ) { parametros[ 'rolId' ] = $( '#rolFiltro' ).val(); }
        if ( $( '#statusFiltro' ).length > 0 && $( '#statusFiltro' ).val() != '' && $( '#statusFiltro' ).val() != null ) { parametros[ 'statusId' ] = $( '#statusFiltro' ).val(); }
        if ( $( '#activoFiltro' ).length > 0 && $( '#activoFiltro' ).val() != '' && $( '#activoFiltro' ).val() != null ) { parametros[ 'activo' ] = $( '#activoFiltro' ).val(); }
		if ( $( '#paisFiltro' ).length > 0 && $( '#paisFiltro' ).val() != '' && $( '#paisFiltro' ).val() != null ) { parametros[ 'paisId' ] = $( '#paisFiltro' ).val(); }
		if ( $( '#estadoFiltro' ).length > 0 && $( '#estadoFiltro' ).val() != '' && $( '#estadoFiltro' ).val() != null ) { parametros[ 'estadoId' ] = $( '#estadoFiltro' ).val(); }
        tablePage = $( '#generalTable' ).DataTable( {
			dom: 'Bfrltip',
			buttons: [],
			processing: true,
			serverSide: true,
			paging: true,
			ajax: {
				url: 'api/controller/list/' + tablaActual,
				type: 'POST',
				data: parametros
			},
			columns: datos.datos,
			pageLength: 15,
			lengthMenu: [15, 25, 50, 100],
			order: [[0, 'asc']],
			language: {
				"search": 'Buscar',
				"info": "Mostranto _START_ al _END_ de _TOTAL_ elementos",
				"paginate": {
					"first": "Primero",
					"last": "Ultimo",
					"next": "Siguiente",
					"previous": "Anterior"
				}
			}
		} );
	}
}
function elegido( id ) {
	imageChange = false;
	reiniciaLocaciones( 1 );
    subCategoriaActiva = 0;
	$( '#fileList' ).html( '' );
    if ( tablaActual != 'places' ) {
		$( '#generalForm input, #generalForm select, #generalForm textarea, div[contiene="generalForm"] span' ).addClass( 'skeleton' );
	} else {
		selectedFiles = [];
		$( '#fileList' ).html( '' );
	}
	ajaxRequest( false, 'POST', { 'id': id }, 'api/controller/list/' + tablaActual, cargaElegido );
}
function cargaElegido( respuesta ) {
	var datos = JSON.parse( respuesta );
	if ( datos.status == 'Success' ) {
		$( '.requerido' ).attr( 'required', 'required' );
		if ( tablaActual == 'usuarios' && perfil == 1 ) {
			$( 'div[contiene="avatar"]' ).hide();
			let labelAvatar = idioma == 'ES' ? 'Selecciona tu avatar (opcional)' : 'Select your avatar (optional)';
			var avatarHtml = '<span>' + labelAvatar + '</span><br><div class="avataresLinks" contiene="avatarLink">';
			for ( let i = 1; i <= 6; i++ ) {
				avatarHtml += '<a href="javascript:void(0)" class="avatarLink" data-avatar="' + i + '">';
				avatarHtml += '<i class="fas fa-circle-check icono" aria-hidden="true"></i>';
				avatarHtml += '<img src="images/avatares/avatar' + i + '.png" alt="Avatar ' + i + '">';
				avatarHtml += '<label for="avatar' + i + '">Avatar ' + i + '</label>';
				avatarHtml += '<input type="radio" class="avatarCheck" name="avatarRadio" id="avatarRadio' + i + '" value="images/avatares/avatar' + i + '.png">';
				avatarHtml += '<span id="avatar-ann-' + i + '" class="avatar-check-live" aria-live="polite" aria-atomic="true"></span>';
				avatarHtml += '</a>';
			}
			avatarHtml += '</div>';
			$( 'div[contiene="avatar"]' ).after( avatarHtml );
			$( '.avatarLink' ).on( 'click', function() {
				$( '.avatarLink' ).not( this ).find( 'input.avatarCheck' ).prop( 'checked', false );
				$( '.avatarLink' ).not( this ).removeClass( 'checked' );
				let inputCheck = $( this ).find( 'input[type="radio"]' );
				if ( inputCheck.is( ':checked' ) ) {
					inputCheck.prop( 'checked', false );
					$( this ).removeClass( 'checked' );
				} else {
					inputCheck.prop( 'checked', true );
					$( this ).addClass( 'checked' );
				}
			} );
		}
		$.each( datos.datos, function( key, value ) {
			if ( key != 'status' ) {
				if ( key.indexOf( 'multiple' ) != -1 ) {
					var multiples = value;
					var mul = multiples.split( '-' );
					$( '#' + key ).val( mul );
					$( '#' + key ).trigger( 'change' );
				} else {
                    if ( key == 'subcategoriaId' ) { subCategoriaActiva = value; }
					var elementoHTML = $( '#' + key );
					if ( typeof elementoHTML[0] != 'undefined' ) {
						var tipoElemento = elementoHTML[0].nodeName;
						if ( tipoElemento == 'INPUT' ) {
							var subTipo = elementoHTML[0].type;
							if ( subTipo != 'checkbox' && subTipo != 'file') {
								if ( elementoHTML.hasClass( 'color' ) ) {
									elementoHTML.spectrum( 'set', value );
								} else {
									elementoHTML.val( value );
								}
							} else if ( subTipo == 'checkbox' ) {
								var checado = true;
								if ( value == 'S' || value == 'N' ) {
									checado = ( value == 'S' ) ? true : false;
								} else {
									checado = value;
								}
								elementoHTML.prop( 'checked', checado );
                                if ( tablaActual == 'places' ) {
                                    if ( checado ) {
                                        elementoHTML.parent().addClass( 'checked' );
                                    } else {
                                        elementoHTML.parent().removeClass( 'checked' );
                                    }
                                }
							} else if ( subTipo == 'file' ) {
								if ( value != '' && value != 'null' && value != null ) {
									elementoHTML.removeAttr( 'required' );
									elementoHTML.attr( 'cargado', value );
									var rutaFile = 'uploads/' + tablaActual + '/' + value;
									$( '.actualLink[campo="' + key + '"]' ).attr( 'href', rutaFile );
									$( '.actualLink[campo="' + key + '"]' ).show();
									/* if ( tablaActual == 'usuarios' && perfil == 1 ) {
										if ( !value.includes( 'images/' ) ) {
											$( 'div[contiene="avatarLink"]' ).hide();
											$( 'div[contiene="avatar"]' ).show();
										} else {
											$( '.avatarLink' ).find( 'input.avatarCheck[value="' + value + '"]' ).prop( 'checked', true );
											$( '.avatarLink' ).find( 'input.avatarCheck[value="' + value + '"]' ).parent().addClass( 'checked' );
										}
									} */
								}
							}
						} else if ( tipoElemento == 'CANVAS' ) {
							var rutaFile = 'uploads/' + tablaActual + '/' + value;
							$( '.actualLink[campo="' + key + '"]' ).attr( 'href', rutaFile );
							$( '.actualLink[campo="' + key + '"]' ).show();
						} else if ( tipoElemento == 'TEXTAREA' ) {
							if ( elementoHTML.hasClass( 'htmlEditor' ) ) {
								setearHtml( key, value );
							} else {
								elementoHTML.val( value ).trigger( 'change' );
							}
						} else if ( tipoElemento == 'DIV' ) {
							elementoHTML.code( value );
						} else if ( tipoElemento == 'SELECT' ) {
							value = value == null || value == 0 ? '' : value;
							if ( key == 'estadoId' ) { estadoActual = value; }
							else if ( key == 'ciudadId' ) { ciudadActual = value; }
							else if ( key == 'paisId' ) { iniciaLocaciones( 1 ); elementoHTML.val( value ).trigger( 'change' ); }
							else { elementoHTML.val( value ).trigger( 'change' ); }
						}
					}
				}
			}
		} );
		if ( tablaActual == 'usuarios' ) {
			$( 'div[contiene="nivelId"]' ).find( 'label' ).html( 'Nivel Actual' );
			$( 'div[contiene="puntos"]' ).find( 'label' ).html( 'Puntos Actuales' );
			$( '#nivelId option[value=""]' ).html( 'Sin nivel asignado' );
			$( '#nivelId' ).attr( 'disabled', 'disabled' );
			$( '#puntos' ).attr( 'disabled', 'disabled' );
		}
		if ( datoId == 0 ) {
            if ( tablaActual != 'places' ) {
                popup( 'formulario', true );
            } else {
				rutas = [];
				if ( typeof datos.datos.images != 'undefined' ) {
					$.each( datos.datos.images, function( key, value ) {
						rutas.push( { 'id': value.imageId, 'url':  baseUrl + '/uploads/places/' + value.image_url, 'primary': value.is_primary == 'SI' } );
					} );
					reconstruirConFile( rutas )
				}
                popup( 'placePopup', true );
            }
        }
		if ( tablaActual != 'places' ) { $( '#generalForm input, #generalForm select, #generalForm textarea, div[contiene="generalForm"] span' ).removeClass( 'skeleton' ); }
	} else {
		if ( tablaActual != 'places' ) { $( '#generalForm input, #generalForm select, #generalForm textarea, div[contiene="generalForm"] span' ).removeClass( 'skeleton' ); }
		alerta( 'Algo paso intenta de nuevo', 'error', false );
	}
}
function eliminado( id ) {
	seteaSesion( 'eliminaId', id );
	confirmacion( 'Confirmación', '¿Seguro de eliminar este elemento?', continuaBorrado )
}
function continuaBorrado( respuesta ) {
	if ( respuesta ) {
		ajaxRequest( true, 'POST', { 'id': obtenSesion( 'eliminaId' ) }, 'api/controller/delete/' + tablaActual, borrado );
	} else {
		borraSesion( 'eliminaId' );
	}
}
function borrado( respuesta ) {
	cargando( false );
	borraSesion( 'eliminaId' );
	var datos = JSON.parse( respuesta );
	if ( datos.status == 'Success' ) {
		traeGeneral();
		alerta( 'Elemento eliminado con éxito', 'success', false );
	} else {
		alerta( 'Algo paso intenta de nuevo', 'error', false );
	}
}
function cambiaPassType( container ) {
	if ( $( 'div[contiene="' + container + '"] input' ).attr( 'type' ) == 'text' ) {
		$( 'div[contiene="' + container + '"] input' ).attr( 'type', 'password' );
		$( 'div[contiene="' + container + '"] i' ).removeClass( 'fa-lock' ).addClass( 'fa-eye' );
	} else {
		$( 'div[contiene="' + container + '"] input' ).attr( 'type', 'text' )
		$( 'div[contiene="' + container + '"] i' ).removeClass( 'fa-eye' ).addClass( 'fa-lock' );
	}
}
function iniciaFormulario() {
	cargando( true );
	$( '.id' ).val( 0 );
	$( '#formulario form' )[0].reset();
	$( '.actualLink' ).hide();
	$( '#generalForm .select2' ).val( '' ).trigger( 'change' );
	$( '.htmlEditor ' ).val( '' ).trigger( 'change' );
	$( '.requerido' ).attr( 'required', 'required' );
	$( '.password' ).show();
    if ( $( '#usuarioId' ).length && tablaActual != 'usuarios' ) {
        $( '#usuarioId' ).val( obtenSesion( 'usuarioId' ) );
        $( 'div[contiene="usuarioId"]' ).hide();
    }
	if ( $( '.htmlEditor' ).length ) {
		document.querySelectorAll( '.htmlEditor' ).forEach( ( element, index ) => {
			setearHtml( element.id, '' );
		} );
	}
	if ( $( '#tipoFiltro' ).length && $( '#tipoId' ).length ) {
		if ( $( '#tipoFiltro' ).val() != '' && $( '#tipoFiltro' ).val() != null && $( '#tipoFiltro' ).val() != 0 ) {
			$( '#tipoId' ).val( $( '#tipoFiltro' ).val() ).trigger( 'change' );
		}
	}
	if ( tablaActual == 'productos' ) {
		$( 'div[contiene="categoriaId"]' ).hide();
		$( 'div[contiene="catId"]' ).hide();
	} else if ( tablaActual == 'contenidos' ) {
		$( 'div[contiene="portada"]' ).hide();
		$( 'div[contiene="portada"] input' ).removeAttr( 'required' )
	}
	popup( 'formulario', true );
	cargando( false );
}
function guardaFormulario( contenedor ) {
	if ( checaSesion( 'usuarioId' ) ) {
		cargando( true );
		var formData = new FormData();
		var formMultiple = [];
		var hayMultiple = false;
		formData.append( 'tabla', tablaActual );
		if ( contenedor == 'placeForm' && $( '.id' ).val() == 0 ) {
			formData.append( 'statusId', 2 );
			formData.append( 'is_verified', 'N' );
			formData.append( 'has_distintivo_a', 'N' );
		}
		$( '#' + contenedor + ' input[type="text"], #' + contenedor + ' input[type="email"], #' + contenedor + ' input[type="password"], #' + contenedor + ' input[type="hidden"], #' + contenedor + ' select' ).each( function() {
			if ( typeof $( this ).attr( 'id' ) != 'undefined' && $( this ).val() != '' ) {
				if ( typeof $( this ).attr( 'destino' ) != 'undefined' ) {
					var multiples = $( this ).val();
					if ( multiples != null ) {
						multiples = multiples.join( '-' );
					}
					var info = { 'destino': $( this ).attr( 'destino' ), 'ids': multiples }
					formMultiple.push( info );
					hayMultiple = true;
				} else {
					var clase = ( typeof $( this ).attr( 'class' ) == 'undefined' ) ? '' : $( this ).attr( 'class' );
					if ( clase.indexOf( 'noPelar' ) == -1 || typeof clase == 'undefined' ) {
						formData.append( $( this ).attr( 'id' ), $( this ).val() );
					}
				}
			}
		} );
		$( '#' + contenedor + ' textarea' ).each( function() {
			if ( typeof $( this ).attr( 'id' ) != 'undefined' ) {
				if ( $( this ).hasClass( 'htmlEditor' ) ) {
					console.log( 'editor' );
					formData.append( $( this ).attr( 'id' ), obtenHtml( $( this ).attr( 'id' ) ) );
				} else {
					console.log( 'normal' );
					formData.append( $( this ).attr( 'id' ), $( this ).val() );
				}
			}
		} );
		$( '#' + contenedor + ' input[type="checkbox"]' ).each( function() {
			if ( typeof $( this ).attr( 'id' ) != 'undefined' ) {
				var clase = ( typeof $( this ).attr( 'class' ) == 'undefined' ) ? '' : $( this ).attr( 'class' );
				if ( clase.indexOf( 'noPelar' ) == -1 || typeof clase == 'undefined' ) {
					if ( $( this ).hasClass( 'featureCheck' ) ) {
						var valor = ( $( this ).is( ':checked' ) ) ? 'S' : 'N';
						formData.append( $( this ).attr( 'id' ), valor );
					} else {
						var valorSi = ( $( this ).attr( 'tipo' ) == 'SN' ) ? 'S' : true;
						var valorNo = ( $( this ).attr( 'tipo' ) == 'SN' ) ? 'N' : false;
						var valor = ( $( this ).is( ':checked' ) ) ? valorSi : valorNo;
						formData.append( $( this ).attr( 'id' ), valor );
					}
				}
			}
		} );
		if ( contenedor == 'placeForm' ) {
			formData.append( 'imageChange', imageChange ? 'S' : 'N' );
			if ( imageChange ) {
				var dt = new DataTransfer();
				var principal = '';
				$.each( selectedFiles, function( index, item ) {
					if ( item && item.file instanceof File ) {
						dt.items.add( item.file );
					}
					if ( item && item.principal ) {
						principal = index;
					}
				} );
				$( '#placeImages' )[0].files = dt.files;
				if ( principal !== '' ) {
					formData.append( 'principal', principal );
				}
				var files = $( '#placeImages' ).prop( 'files' );
				$.each( files, function( key, value ) {
					formData.append( 'image-' + key, value, value.name );
				} );
			}
		} else {
			var fileList = 0;
			$( '#' + contenedor + ' input[type=file]' ).each( function() {
				var files = $( this ).prop( 'files' );
				var field = $( this ).attr( 'id' );
				$.each( files, function( key, value ) {
					formData.append( field, value );
					fileList++;
				} );
			} );
			if ( tablaActual == 'usuarios' && perfil == 1 && fileList == 0 ) {
				let avatar = $('input[name="avatarRadio"]:checked').val();
				if ( avatar != '' && avatar != null && avatar != 0 && avatar != undefined) {
					formData.append( 'avatar', avatar );
				}
			}
		}
		if ( hayMultiple ) {
			formData.append( 'multiples', JSON.stringify( formMultiple ) );
		}
		var action = $( '.id' ).val() == 0 ? 'add' : 'update';
		$.ajax( {
			type: 'POST',
			url: 'api/controller/' + action + '/' + tablaActual,
			data: formData,
			processData: false,
			contentType: false,
			xhr: function() {
				var xhr = new window.XMLHttpRequest();
				xhr.upload.addEventListener( 'progress', function( evt ) {
					if (evt.lengthComputable) {
						var percentComplete = evt.loaded / evt.total;
						percentComplete = percentComplete * 100;
						porcentaje( percentComplete.toFixed( 2 ) );
					}
				}, false);
				xhr.addEventListener("progress", function(evt){
					if (evt.lengthComputable) {
						var percentComplete = evt.loaded / evt.total;
						percentComplete = percentComplete * 100;
						porcentaje( percentComplete.toFixed( 2 ) );
					}
				}, false );
				console.log( 'porcentaje' );
				return xhr;
			}, success: function( response ) {
				categoriaActual = 0;
				var datos = JSON.parse( response );
				reiniciaProgreso();
				imageChange = false;
				if ( datos.status == 'Success' ) {
					if ( archivoUsado == 'agregar-lugar.php' ) {
						var msg = idioma == 'ES' ? 'Lugar almacenado con éxito, en breve se revisara la información para su aprobación' : 'Place stored successfully, the information will be reviewed for approval shortly';
						alertaCallBack( msg, 'success', function() { manda( '/' ) } );
					} else if ( archivoUsado == 'sugerir-categoria.php' ) {
						var msg = idioma == 'ES' ? 'Categoria almacenado con éxito, en breve se revisara la información para su aprobación' : 'Category stored successfully, the information will be reviewed for approval shortly';
						alerta( msg, 'success', false );
						$( '#categoryForm' )[0].reset();
					} else if ( archivoUsado == 'validar-negocio.php' ) {
						/* var msg = idioma == 'ES' ? 'Solicitud de validación almacenada con éxito, por favor realiza el pago para proceder' : 'Validation request stored successfully, please proceed with the payment';
						alerta( msg, 'success', false );
						$( '#paypalButtons' ).show();
						$( '#validaBoton' ).hide(); */
						var msg = idioma == 'ES' ? 'Solicitud de validación almacenada con éxito, en breve te contáctaremos para continuar con el proceso' : 'Validation request stored successfully, we will contact you shortly to proceed';
						alerta( msg, 'success', false );
						$( '#generalForm' )[0].reset();
					} else {
						var msg = idioma == 'ES' ? 'Información almacenada con éxito' : 'Information stored successfully';
						if ( unicoData != 1 || datoId == 0 ) {
							traeGeneral();
							let typeAlert = 'success';
							if ( datos.noSubidas != '' ) {
								typeAlert = 'warning';
								msg = idioma == 'ES' ? msg + ', algunas de las imagenes ingresadas no fueron almacenadas(' + datos.noSubidas + '), intente con otra imagen con un distinto formato' : msg + ', some of the uploaded images were not saved (' + data.noUploads + '), Try another image with a different format';
							}
							popup( 'formulario', false );
							alerta( msg, typeAlert, false );
						} else {
							alerta( msg, 'success', false );
						}
					}
					cargando( false );
				} else {
					cargando( false );
					var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
					alerta( msg, 'error', false );
				}
			}
		} );
	} else {
		var msg = idioma == 'ES' ? 'Debes iniciar sesión para realizar esta acción' : 'You must log in to perform this action';
		alerta( msg, 'error', false );
	}
}
function reiniciaProgreso() {
	if ( $( '#progressBar' ).is( ':visible' ) ) { $( '#progressBar' ).hide(); $( "#progressBar" ).attr( "aria-hidden", true ); }
	$( "#progressBar" ).progressbar( { value: 0 } );
	$( "#progressBar" ).attr( "aria-valuenow", 0 );
	$( "#progressBar" ).attr( "aria-valuetext", '0%' );
}
function porcentaje( valor ) {
	if ( !$( '#progressBar' ).is( ':visible' ) ) { $( '#progressBar' ).show(); $( "#progressBar" ).attr( "aria-hidden", false ); }
	$( "#progressBar" ).progressbar( { value: valor } );
	$( "#progressBar" ).attr( "aria-valuenow", valor );
	$( "#progressBar" ).attr( "aria-valuetext", valor + '%' );
}
function readIconList() {
	ajaxRequest( true, 'POST', {}, 'dist/icons.json', iconosLista );
}
function iconosLista( response ) {
	cargando( false );
	$.each( response, function( tipo, iconos ) {
		$.each( iconos, function( indice, icono ) {
			var iconClass = 'fa' + tipo.substring( 0, 1 ) + ' ' + icono;
			fontAwesome.push( { 'icon': iconClass } )
		} );
	} );
}
function obtenHtml( id ) {
	if ( editor[ id ] ) {
		return editor[id].getData();
	}
	return '';
}
function setearHtml( id, contenido ) {
	if ( editor[ id ] ) {
		editor[ id ].setData( contenido );
	}
}
function aprobarValidador( aplicacionId ) {
    ajaxRequest( true, 'POST', { 'id': aplicacionId }, 'api/account/aprobar', aprobado );
}
function aprobado( response ) {
    cargando( false );
    var datos = JSON.parse( response );
    if ( datos.status == 'Success' ) {
        traeGeneral();
        var msg = idioma == 'ES' ? 'Acceso otorgado con éxito' : 'Access granted successfully';
        alerta( msg, 'success', false );
    } else {
        var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}
function revocar( usuarioId ) {
    ajaxRequest( true, 'POST', { 'id': usuarioId }, 'api/account/revocar', revocado );
}
function revocado( response ) {
    cargando( false );
    var datos = JSON.parse( response );
    if ( datos.status == 'Success' ) {
        traeGeneral();
        var msg = idioma == 'ES' ? 'Acceso revocado con éxito' : 'Access revoked successfully';
        alerta( msg, 'success', false );
    } else {
        var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}
function actualizaPosiciones() {
	var posicionamiento = [];
	$( 'tbody.ordenable tr' ).each( function() {
		var posicion = $( this ).index() + 1;
		var elementoId = $( this ).find( '.arrastrable' ).attr( 'campoId' );
		posicionamiento.push( { 'id': elementoId, 'posicion': posicion } );
	} );
	ajaxRequest( true, 'POST', { 'posiciones': posicionamiento }, 'api/controller/order/' + tablaActual, posicionSuccess );
}
function posicionSuccess( respuesta ) {
	cargando( false );
	var datos = JSON.parse( respuesta );
	if ( datos.status == 'Success' ) {
		console.log( 'posicionado' )
	}
}
function aprobar( lugarId ) {
    ajaxRequest( true, 'POST', { 'lugarId': lugarId }, 'api/lugar/aprobar', lugarAprobado );
}
function lugarAprobado( response ) {
    cargando( false );
    var datos = JSON.parse( response );
    if ( datos.status == 'Success' ) {
        traeGeneral();
        var msg = idioma == 'ES' ? 'Lugar aprobado con éxito' : 'Place approved successfully';
        alerta( msg, 'success', false );
    } else {
        var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}
function rechazar( lugarId ) {
    ajaxRequest( true, 'POST', { 'lugarId': lugarId }, 'api/lugar/rechazar', lugarRechazado );
}
function lugarRechazado( response ) {
    cargando( false );
    var datos = JSON.parse( response );
    if ( datos.status == 'Success' ) {
        traeGeneral();
        var msg = idioma == 'ES' ? 'Lugar rechazado con éxito' : 'Place rejected successfully';
        alerta( msg, 'success', false );
    } else {
        var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}
function reabrir( lugarId ) {
    ajaxRequest( true, 'POST', { 'lugarId': lugarId }, 'api/lugar/reabrir', lugarPendiente );
}
function lugarPendiente( response ) {
    cargando( false );
    var datos = JSON.parse( response );
    if ( datos.status == 'Success' ) {
        traeGeneral();
        var msg = idioma == 'ES' ? 'Lugar reabierto con éxito' : 'Place reopened successfully';
        alerta( msg, 'success', false );
    } else {
        var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}
function selectJqueryPorOtroTipo( tipo ) {
	if ( tipo == 'paises' ) {
		return $( '#paisId' ).length ? $( '#paisId' ) : $( '#busquedaPaisId' );
	}
	if ( tipo == 'estados' ) {
		return $( '#estadoId' ).length ? $( '#estadoId' ) : $( '#busquedaEstadoId' );
	}
	if ( tipo == 'ciudades' ) {
		return $( '#ciudadId' ).length ? $( '#ciudadId' ) : $( '#busquedaCiudadId' );
	}
	return $();
}
function ubicacionPadreSeleccionada( val ) {
	if ( val === null || val === undefined ) {
		return false;
	}
	var s = String( val ).trim();
	return s !== '' && s !== '0' && s !== '-1';
}
function otroDato( tipo ) {
	let tipoTxt = '';
	otroTipo = tipo == 1 ? 'paises' : ( tipo == 2 ? 'estados' : 'ciudades' );
	if ( otroTipo == 'estados' ) {
		if ( !ubicacionPadreSeleccionada( selectJqueryPorOtroTipo( 'paises' ).val() ) ) {
			var msgPais = idioma == 'ES' ? 'Elige primero un país válido' : 'Please select a valid country first';
			alerta( msgPais, 'error', false );
			return;
		}
	}
	if ( otroTipo == 'ciudades' ) {
		if ( !ubicacionPadreSeleccionada( selectJqueryPorOtroTipo( 'estados' ).val() ) ) {
			var msgEstado = idioma == 'ES' ? 'Elige primero un estado válido' : 'Please select a valid state first';
			alerta( msgEstado, 'error', false );
			return;
		}
	}
	if ( idioma == 'ES' ) {
		tipoTxt = tipo == 1 ? 'Pais' : ( tipo == 2 ? 'Estado' : 'Ciudad' );
	} else {
		tipoTxt = tipo == 1 ? 'Country' : ( tipo == 2 ? 'State' : 'City' );
	}
    let msg = idioma == 'ES' ? 'Ingresa el nombre del ' + tipoTxt + ' que deseas agregar' : 'Enter the name of the ' + tipoTxt + ' you want to add';
    ingresaDato( msg, 'text', null, newOther );
}
function newOther( respuesta ) {
    if ( respuesta.isConfirmed && respuesta.value != '' ) {
		otroNombreSugerido = String( respuesta.value ).trim();
		var parametros = {
			'nombre': otroNombreSugerido,
			'activo': 'N'
		};
		if ( otroTipo == 'estados' ) {
			parametros[ 'paisId' ] = selectJqueryPorOtroTipo( 'paises' ).val();
		} else if ( otroTipo == 'ciudades' ) {
			parametros[ 'estadoId' ] = selectJqueryPorOtroTipo( 'estados' ).val();
		}
        ajaxRequest( true, 'POST', parametros, 'api/controller/add/' + otroTipo, otroCreado );
    }
}
function otroCreado( respuesta ) {
    cargando( false );
    var datos =  JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
		var $sel = selectJqueryPorOtroTipo( otroTipo );
		if ( $sel.length && datos.id !== undefined && datos.id !== null && datos.id !== '' ) {
			var idStr = String( datos.id );
			var etiqueta = otroNombreSugerido !== '' ? otroNombreSugerido : idStr;
			$sel.find( 'option' ).filter( function() { return $( this ).val() === idStr; } ).remove();
			var $nuevo = $( '<option></option>' ).val( idStr ).text( etiqueta );
			var $sugerir = $sel.find( 'option[value="-1"]' );
			if ( $sugerir.length ) {
				$nuevo.insertBefore( $sugerir );
			} else {
				$sel.append( $nuevo );
			}
			$sel.val( idStr ).trigger( 'change' );
		}
		otroNombreSugerido = '';
		let msg = idioma == 'ES' ? 'Sugerencia de ubicacion agregada con éxito' : 'Location suggestion added successfully';
        alerta( msg, 'success', false );
    } else {
		let msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}
function sugerenciasUbicaciones() {
	borraSesion( 'sugerenciaId' );
	borraSesion( 'sugerenciaTipo' );
	if ( typeof tablePage != 'undefined' ) { tablePage.destroy(); }
	var parametros = { 'rol': obtenSesion( 'rolId' ), 'usuarioId': obtenSesion( 'usuarioId' ), 'required': 'N' };
	tablePage = $( '#generalTable' ).DataTable( {
		dom: 'Bfrltip',
		buttons: [],
		processing: true,
		serverSide: true,
		paging: true,
		ajax: {
			url: 'api/lugar/sugerencias',
			type: 'POST',
			data: parametros
		},
		columns: [
			{ 'data': 'action', 'name': 'action', 'exportable': false, 'orderable': false },
			{ 'data': 'ubicacion', 'name': 'ubicacion' }
		],
		pageLength: 15,
		lengthMenu: [15, 25, 50, 100],
		order: [[0, 'asc']],
		language: {
			"search": 'Buscar',
			"info": "Mostranto _START_ al _END_ de _TOTAL_ elementos",
			"paginate": {
				"first": "Primero",
				"last": "Ultimo",
				"next": "Siguiente",
				"previous": "Anterior"
			}
		}
	} );
}
function aprobarSugerencia( id, tipo ) {
    ajaxRequest( true, 'POST', { 'id': id, 'tipo': tipo }, 'api/lugar/aprobar-sugerencia', sugerenciaAprobada );
}
function sugerenciaAprobada( response ) {
    cargando( false );
    var datos = JSON.parse( response );
    if ( datos.status == 'Success' ) {
        sugerenciasUbicaciones();
        var msg = idioma == 'ES' ? 'Sugerencia aprobada con éxito' : 'Suggestion approved successfully';
        alerta( msg, 'success', false );
    } else {
        var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}
function editarSugerencia( id, nombre, tipo ) {
	seteaSesion( 'sugerenciaId', id );
	seteaSesion( 'sugerenciaTipo', tipo );
	let tipoTxt = tipo == 1 ? 'Pais' : ( tipo == 2 ? 'Estado' : 'Ciudad' );
	ingresaDato( 'Ingresa el nombre del ' + tipoTxt + ' que deseas agregar', 'text', nombre, updateSugerencia );
}
function updateSugerencia( respuesta ) {
	if ( respuesta.isConfirmed && respuesta.value != '' ) {
		var parametros = {
			'id': obtenSesion( 'sugerenciaId' ),
			'nombre': respuesta.value,
			'tipo': obtenSesion( 'sugerenciaTipo' )
		};
		ajaxRequest( true, 'POST', parametros, 'api/lugar/editar-sugerencia', sugerenciaActualizada );
	}
}
function sugerenciaActualizada( respuesta ) {
	cargando( false );
	var datos = JSON.parse( respuesta );
	if ( datos.status == 'Success' ) {
		var msg = idioma == 'ES' ? 'Sugerencia actualizada y autorizada con éxito' : 'Suggestion updated and authorized successfully';
		alerta( msg, 'success', false );
		sugerenciasUbicaciones();
	} else {
		var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
		alerta( msg, 'error', false );
	}
}
function distintivo( lugarId ) {
    ajaxRequest( true, 'POST', { 'lugarId': lugarId }, 'api/lugar/distintivo', distintivoAsignado );
}
function distintivoAsignado( response ) {
    cargando( false );
    var datos = JSON.parse( response );
    if ( datos.status == 'Success' ) {
        traeGeneral();
        var msg = idioma == 'ES' ? 'Distintivo asignado con éxito' : 'Distinctive assigned successfully';
        alerta( msg, 'success', false );
    } else {
        var msg = idioma == 'ES' ? 'Algo paso intenta de nuevo' : 'Something went wrong, please try again';
        alerta( msg, 'error', false );
    }
}